var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218,
    height: 192,
    viewBox: "0 0 218 192",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4492 140.239C30.4493 140.239 31.2603 139.428 31.2603 138.428C31.2603 137.428 30.4493 136.617 29.4492 136.617C28.4492 136.617 27.6382 137.428 27.6382 138.428C27.6382 139.428 28.4492 140.239 29.4492 140.239Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.885 64.5481C131.418 64.5481 115.673 63.9199 100.945 59.8174C86.4946 55.8074 73.2266 48.0279 61.3998 39.0282C53.6571 33.1703 46.6163 28.4949 36.5637 29.1974C26.7291 29.7296 17.3245 33.4021 9.73197 39.6751C-3.0556 50.8734 -1.13366 71.6258 3.98492 86.1504C11.6723 108.085 35.0669 123.368 54.9506 133.254C77.9204 144.729 103.163 151.4 128.461 155.226C150.636 158.607 179.131 161.047 198.35 146.577C215.997 133.254 220.839 102.874 216.515 82.3621C215.465 76.3025 212.239 70.835 207.441 66.9873C195.042 57.9139 176.544 63.9752 162.611 64.2707C157.436 64.3819 152.17 64.5112 146.885 64.5481Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.675 157.517C126.198 157.517 135.538 148.176 135.538 136.654C135.538 125.132 126.198 115.791 114.675 115.791C103.153 115.791 93.8125 125.132 93.8125 136.654C93.8122 148.176 103.153 157.517 114.675 157.517Z",
    fill: "#D2D2D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1165 6.40568C94.2699 6.14845 95.4629 6.12099 96.627 6.32469C97.7912 6.52839 98.9035 6.95977 99.9012 7.59312C100.899 8.22681 101.762 9.051 102.441 10.0181C103.12 10.9855 103.602 12.077 103.859 13.2303L107.193 28.1825L89.5896 32.1073L86.2557 17.1556C85.9978 15.9991 85.971 14.8029 86.1764 13.6356C86.3819 12.4687 86.8157 11.3539 87.4532 10.3549C88.0907 9.35585 88.9191 8.49308 89.891 7.81524C90.8629 7.13775 91.959 6.65839 93.1165 6.40568Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 5.3161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.361 123.7L68.3846 147.538C67.72 147.688 67.0282 147.66 66.3772 147.461C65.7261 147.261 65.1386 146.895 64.6721 146.398C64.206 145.903 63.8768 145.293 63.7176 144.632C63.5584 143.968 63.5747 143.277 63.7649 142.623L64.2084 141.089C67.9042 127.987 71.1196 113.555 68.1629 100.25L61.8429 71.8657C56.521 48.0092 70.8238 23.7087 94.551 17.8508C100.337 16.4145 106.351 16.1499 112.241 17.0728C118.131 17.9957 123.776 20.0873 128.845 23.2245C133.915 26.3617 138.304 30.4812 141.758 35.3405C145.212 40.1997 147.658 45.701 148.954 51.5197L155.477 80.8647C158.452 94.1698 167.433 105.923 176.414 116.16L177.467 117.361C177.894 117.876 178.182 118.49 178.307 119.146C178.429 119.803 178.384 120.481 178.173 121.115C177.963 121.749 177.593 122.319 177.102 122.771C176.61 123.224 176.01 123.544 175.361 123.7Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 5.3161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2329 105.406C96.2037 101.089 97.6539 96.8937 100.342 93.5167C103.03 90.1396 106.793 87.7853 111.006 86.8453C115.219 85.9057 119.626 86.4372 123.495 88.3519C127.364 90.2662 130.459 93.4482 132.267 97.3675",
    stroke: "#BABABA",
    strokeWidth: 5.3161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.237 75.4141C130.686 75.4141 131.861 74.2392 131.861 72.79C131.861 71.3408 130.686 70.1659 129.237 70.1659C127.788 70.1659 126.613 71.3408 126.613 72.79C126.613 74.2392 127.788 75.4141 129.237 75.4141Z",
    fill: "#BABABA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5458 84.4871C89.9949 84.4871 91.1699 83.3121 91.1699 81.863C91.1699 80.4138 89.9949 79.2388 88.5458 79.2388C87.0966 79.2388 85.9216 80.4138 85.9216 81.863C85.9216 83.3125 87.0962 84.4871 88.5458 84.4871Z",
    fill: "#BABABA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.479 3.62198C138.478 3.62198 139.29 2.81101 139.29 1.81093C139.29 0.810854 138.478 -0.00012207 137.479 -0.00012207C136.479 -0.00012207 135.668 0.810854 135.668 1.81093C135.668 2.81101 136.479 3.62198 137.479 3.62198Z",
    fill: "#CFCFCF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4492 140.239C30.4493 140.239 31.2603 139.428 31.2603 138.428C31.2603 137.428 30.4493 136.617 29.4492 136.617C28.4492 136.617 27.6382 137.428 27.6382 138.428C27.6382 139.428 28.4492 140.239 29.4492 140.239Z",
    fill: "#CFCFCF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M187.521 45.5515V53.4976",
    stroke: "#BABABA",
    strokeWidth: 5.3161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M183.548 49.5248H191.494",
    stroke: "#BABABA",
    strokeWidth: 5.3161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.143 165.186V173.132",
    stroke: "#BABABA",
    strokeWidth: 5.3161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.169 169.159H195.115",
    stroke: "#BABABA",
    strokeWidth: 5.3161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2156 15.4304V23.3764",
    stroke: "#BABABA",
    strokeWidth: 5.3161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2424 19.4035H56.1885",
    stroke: "#BABABA",
    strokeWidth: 5.3161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.778 191.186C147.243 191.186 177.616 189.292 177.616 186.954C177.616 184.617 147.243 182.723 109.778 182.723C72.3127 182.723 41.9409 184.617 41.9409 186.954C41.9409 189.292 72.3127 191.186 109.778 191.186Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M174.585 41.0427C174.58 46.6625 172.345 52.0509 168.372 56.0248C164.397 59.9986 159.009 62.2334 153.389 62.2383C152.698 62.238 152.007 62.2011 151.32 62.1274L145.036 72.3833L143.078 59.5401C139.814 57.7225 137.087 55.0744 135.176 51.8639C133.265 48.6533 132.237 44.9951 132.195 41.2589C132.153 37.5232 133.1 33.8423 134.938 30.5901C136.778 27.3378 139.443 24.6292 142.666 22.7389C145.888 20.8486 149.555 19.844 153.289 19.8263C157.026 19.8089 160.702 20.7794 163.941 22.6395C167.182 24.4996 169.873 27.1831 171.741 30.418C173.611 33.6529 174.592 37.3247 174.585 41.0608L174.585 41.0427Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 5.3161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.335 43.186C145.519 43.186 146.478 42.2262 146.478 41.0423C146.478 39.8587 145.519 38.8986 144.335 38.8986C143.15 38.8986 142.191 39.8583 142.191 41.0423C142.191 42.2266 143.15 43.186 144.335 43.186Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 5.3161,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M153.389 43.186C154.574 43.186 155.533 42.2262 155.533 41.0423C155.533 39.8587 154.574 38.8986 153.389 38.8986C152.205 38.8986 151.246 39.8583 151.246 41.0423C151.246 42.2266 152.205 43.186 153.389 43.186Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 5.3161,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M162.444 43.186C163.629 43.186 164.588 42.2262 164.588 41.0423C164.588 39.8587 163.629 38.8986 162.444 38.8986C161.259 38.8986 160.3 39.8583 160.3 41.0423C160.3 42.2266 161.259 43.186 162.444 43.186Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 5.3161,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellIcon);
export default __webpack_public_path__ + "static/media/notification-bell-icon.3a9f096af83c0d91ec1e1754c46d81f4.svg";
export { ForwardRef as ReactComponent };